export default function styleToObj(style = '') {
  return style.split(';')
    .filter(line => line)
    .reduce((obj, line) => {
      const [key, value] = line.split(':')
      obj[key] = value.trim()
      return obj
    }, {})
}
